import { Component, Input, OnInit } from '@angular/core';
import { ContentService } from 'src/app/services/content.service';
import { PlayerSessionService } from 'src/app/services/player-session.service';
import { PlayerService } from 'src/app/services/player.service';
import { StatesService } from 'src/app/services/states.service';

@Component({
  selector: 'app-button-component',
  templateUrl: './button-component.component.html',
  styleUrls: ['./button-component.component.scss'],
})
export class ButtonComponentComponent implements OnInit {
  @Input() component: any;

  constructor(
    private playerSessionService: PlayerSessionService,
    private playerService: PlayerService,
    public statesService: StatesService,
    public contentService: ContentService
  ) {}
  ngOnInit(): void {}

  onButtonPressed() {
    this.playerSessionService.addToLog('buttonPressed', {
      id: this.component.id,
      text: this.component.data.text,
    });
    this.playerService.doActions(
      this.component.data.actions,
      'buttonPressed',
      this.component
    );
    if (this.component.data.url) {
      window.open(this.component.data.url, '_blank');
    }
  }

  onFocus() {
    this.statesService.onFocus(this.component);
  }
  onBlur() {
    this.statesService.onBlur(this.component);
  }
  onFocusOut() {
    this.statesService.onFocusOut(this.component);
  }
  onMouseDown() {
    this.statesService.onMouseDown(this.component);
  }
  onMouseUp() {
    this.statesService.onMouseUp(this.component);
  }

  onMouseEnter() {
    this.statesService.onMouseEnter(this.component);
  }
  onMouseLeave() {
    this.statesService.onMouseLeave(this.component);
  }
}
